export function flattenOnKey<A extends Record<K, A[]>, K extends string>(
  ar: A[],
  key: K,
): Omit<A, K>[] {
  return ar
    .map(({ [key]: next, ...reply }) => [reply, ...flattenOnKey(next, key)])
    .flat()
}
